.vc-mentionAvatars-icon {
    vertical-align: middle;
    width: 1em !important; /* insane discord sets width: 100% in channel topic */
    height: 1em;
    margin: 0 4px 0.2rem 2px;
    box-sizing: border-box;
}

.vc-mentionAvatars-role-icon {
    margin: 0 2px 0.2rem 4px;
}

/** don't display inside the ServerInfo modal owner mention */
.vc-gp-owner .vc-mentionAvatars-icon {
    display: none;
}
